var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLgbtqDiversity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Romance-Pride-Lesbian-Lgbt-Heart--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Romance Pride Lesbian Lgbt Heart Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.41 21.06a2.48 2.48 0 0 0 3.59 0l4.05 -4.22H6.37Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.33 12.63 2.12 2.21H20l2.11 -2.2a6.05 6.05 0 0 0 1.34 -2H1a6.14 6.14 0 0 0 1.33 1.99Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.22 5.56A6.13 6.13 0 0 0 13.41 4l-1.2 1.2L11 4a6.07 6.07 0 0 0 -5.31 -1.74 6.06 6.06 0 0 0 -4.5 3.3 6.29 6.29 0 0 0 -0.64 3.07h23.31a6.08 6.08 0 0 0 -0.64 -3.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLgbtqDiversity);
export default ForwardRef;